import Vue from "@/main";
import { roadModelData } from "./Shinbashi";

export function dateNumFun(modelId, showArr) {
  let tilesetLayer = Vue.$GLOBAL.map.getLayer(
    "NewNode-37a36db7-a445-4e72-95b1-dfa572ee4aa7",
    "modelId"
  );
  if (tilesetLayer) {
    const conditions = [];

    for (let index = 0; index < showArr.length; index++) {
      const element = showArr[index];
      conditions.push(["${id} ==='" + element + "' ", "rgb(255, 255, 255,1)"]);
      // console.log("数据", conditions, showArr);
    }
    conditions.push(["true", "rgba(255, 255, 255,0)"]);

    tilesetLayer.style = new Cesium.Cesium3DTileStyle({
      color: {
        conditions: conditions,
      },
    });
  }
}
